import React from 'react';
import { APP_ORDER_DEAL_STATUS_PERMISSION } from 'pages/AppOrderDealStatus/utils/constants';

const AppOrderDealStatusPage = React.lazy(() => import('pages/AppOrderDealStatus/AppOrderDealStatusPage'));
const AppOrderDealStatusAddPage = React.lazy(() => import('pages/AppOrderDealStatus/AppOrderDealStatusAddPage'));

const appOrderDealStatusRoute = [
  {
    path: '/app-order-deal-status',
    exact: true,
    name: 'Trạng thái deal app',
    function: APP_ORDER_DEAL_STATUS_PERMISSION.VIEW,
    component: AppOrderDealStatusPage,
  },
  {
    path: '/app-order-deal-status/add',
    exact: true,
    name: 'Thêm trạng thái deal app',
    function: APP_ORDER_DEAL_STATUS_PERMISSION.ADD,
    component: AppOrderDealStatusAddPage,
  },
  {
    path: '/app-order-deal-status/edit/:id',
    exact: true,
    name: 'Chỉnh sửa trạng thái deal app',
    function: APP_ORDER_DEAL_STATUS_PERMISSION.EDIT,
    component: AppOrderDealStatusAddPage,
  },
  {
    path: '/app-order-deal-status/detail/:id',
    exact: true,
    name: 'Chi tiết trạng thái deal app',
    function: APP_ORDER_DEAL_STATUS_PERMISSION.VIEW,
    component: AppOrderDealStatusAddPage,
  },
];

export default appOrderDealStatusRoute;
